import { useTranslation } from "react-i18next";
import React from "react";
import { Link } from "react-router-dom";

const ChatButton: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-end space-x-4">
      <Link
        to={"kakao"}
        className="bg-[#FEE500] justify-center rounded-full flex items-center gap-2 w-[5.3125rem] h-[2.5rem]"
      >
        <img className="w-4 h-4" src="../../assets/icons/chat.svg" alt="Chat" />
        <div className="font-noto-sans text-[0.875rem] font-semibold text-left">
          {t("Chat")}
        </div>
      </Link>
    </div>
  );
};

export default ChatButton;
